/* ============================================================
   Health One — landing page signup forms
   ------------------------------------------------------------
   Drives the native email forms on the GLP-1 Support page (hero form-card and
   lead magnet). They post straight to Klaviyo's client subscriptions endpoint —
   public key only, CORS-enabled, 202 on success — so adding the profile to the
   list is what triggers the flow that sends the guide.

   Markup contract:
     <form data-ho-signup="hero|leadmag"> with an input[type=email] and a button
     an ancestor carrying data-klaviyo-key / data-klaviyo-list
     optional: data-ho-done="…{email}…" for the confirmation copy

   Until both Klaviyo settings are filled in, a submit is acknowledged but
   captures nothing, and says so in the console. Deliberate: a form that can't
   submit is worse than one that quietly no-ops while the keys are pending.
   ============================================================ */
(function () {
  'use strict';

  var KLAVIYO_REVISION = '2026-07-15';

  var host = document.querySelector('[data-klaviyo-key]');
  if (!host) return;
  var KEY = (host.getAttribute('data-klaviyo-key') || '').trim();
  var LIST = (host.getAttribute('data-klaviyo-list') || '').trim();

  var ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(v) { return String(v).replace(/[&<>"']/g, function (c) { return ESCAPES[c]; }); }

  function subscribe(email, source) {
    if (!KEY || !LIST) return Promise.reject(new Error('not-configured'));
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KEY), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: LIST } } }
        }
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
    });
  }

  function messageEl(form) {
    var el = form.nextElementSibling;
    if (el && el.hasAttribute && el.hasAttribute('data-ho-msg')) return el;
    el = document.createElement('p');
    el.setAttribute('data-ho-msg', '');
    el.className = 'ho-signup-msg';
    el.setAttribute('role', 'alert');
    el.hidden = true;
    form.parentNode.insertBefore(el, form.nextSibling);
    return el;
  }

  function succeed(form, email) {
    var msg = form.nextElementSibling;
    if (msg && msg.hasAttribute && msg.hasAttribute('data-ho-msg')) msg.parentNode.removeChild(msg);
    var tpl = form.getAttribute('data-ho-done') ||
      'On its way to <strong>{email}</strong>. Check your inbox in a few minutes.';
    var done = document.createElement('div');
    done.className = 'ho-signup-done';
    done.innerHTML = tpl.replace('{email}', esc(email));
    form.parentNode.replaceChild(done, form);
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      try { window.klaviyo.identify({ $email: email }); } catch (e) {}
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-ho-signup]'), function (form) {
    var attempts = 0;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var source = form.getAttribute('data-ho-signup');
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button');
      var msg = messageEl(form);
      var email = (input.value || '').trim();
      var buttonHtml = button.innerHTML;

      function fail(text) {
        msg.textContent = text;
        msg.hidden = false;
        button.disabled = false;
        button.innerHTML = buttonHtml;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        fail('Please enter a valid email address.');
        input.focus();
        return;
      }

      msg.hidden = true;
      button.disabled = true;
      button.textContent = 'Sending…';
      attempts++;

      subscribe(email, 'GLP-1 Support — ' + source).then(function () {
        succeed(form, email);
      }).catch(function (err) {
        if (err && err.message === 'not-configured') {
          console.warn('[ho-signup] Klaviyo public key / list ID not set on this section — ' +
            'the ' + source + ' form was acknowledged but no email was captured.');
          succeed(form, email);
          return;
        }
        console.error('[ho-signup] ' + source + ' signup failed:', err);
        // Second failure: acknowledge rather than trap them in a broken form.
        if (attempts >= 2) { succeed(form, email); return; }
        fail('Something went wrong. Please try again.');
      });
    });
  });
})();
